



































import Vue from "vue";
import Component from "vue-class-component";
import { LControl } from "vue2-leaflet";
import { maps } from "@/store";
import { MutationTypes } from "@/store/mutations-types";

@Component({
  components: {
    LControl,
  },
})
export default class MeasurementControl extends Vue {
  get distance(): string {
    const distance = maps.getters.totalDistance.toFixed(2);
    return this.measurementUnits ? `${distance} nm` : `${distance} km`;
  }

  get measurementUnits() {
    return maps.getters.measurementUnits;
  }
  get measurementActivated() {
    return maps.getters.measurementActivated;
  }

  activateMeasure() {
    maps.dispatch("activateMeasurement");
  }
  changeUnits() {
    maps.commit(MutationTypes.CHANGE_MEASUREMENTS_UNITS);
  }
}
